export default class {

    Id = null;

    Name = null;

    IsParent = false;

    ParentId = null;

    StandardBooks = [];

    SubTags = null;

    mapFromDto(modelDto) {
        if (!modelDto)
        return this;

        this.Id = modelDto.Id;
        this.Name = modelDto.Name;
        this.IsParent = modelDto.IsParent;
        this.ParentId = modelDto.ParentId;

        if(modelDto.StandardBooks)
            this.StandardBooks = modelDto.StandardBooks;

        this.SubTags = modelDto.SubTags;
        
        return this;
    }

    isInValid() {
        return !Boolean(this.Name) ||
                        (!this.IsParent && 
                        (!this.ParentId || !this.StandardBooks.length));
    }

    mapToDto = function() {
	    var result = JSON.parse(JSON.stringify(this));

        if(!result.IsParent) {
            result.ParentId = result.ParentId.Id;

            if(result.StandardBooks && result.StandardBooks.length)
                result.StandardBooks = result.StandardBooks.map(e => e.Id);
        }
        

        if(result.IsParent && result.SubTags && result.SubTags.length)
            result.SubTags = result.SubTags.map(e => e.Id);

	    return result;
    }
}